<template>
	<v-app>
		<!-- God Mode -->
		<god-mode v-if="isLoggedIn && roleRef == '2fa99' && !['PayByLinkPayment'].includes($route.name)"></god-mode>

		<!-- Administrator -->
		<administrator v-if="isLoggedIn && roleRef == '7bd7a' && !['PayByLinkPayment'].includes($route.name)" :showPos="showNiPos"></administrator>

		<!-- Manager -->
		<manager v-if="isLoggedIn && roleRef == 'e7712' && !['PayByLinkPayment'].includes($route.name)" :showPos="showNiPos"></manager>

		<!-- Super User -->
		<super-user v-if="isLoggedIn && roleRef == 'cjuw7' && !['PayByLinkPayment'].includes($route.name)" :showPos="showNiPos"></super-user>

		<!-- User High -->
		<user-high v-if="isLoggedIn && roleRef == 'd6f0b' && !['PayByLinkPayment'].includes($route.name)" :showPos="showNiPos"></user-high>

		<!-- User Medium -->
		<user-medium v-if="isLoggedIn && roleRef == '4e3e0' && !['PayByLinkPayment'].includes($route.name)" :showPos="showNiPos"></user-medium>

		<!-- User Low -->
		<user-low v-if="isLoggedIn && roleRef == 'fc6c1' && !['PayByLinkPayment'].includes($route.name)" :showPos="showNiPos"></user-low> 

		<!-- Cybersource -->
		<cybersource v-if="isLoggedIn && roleRef == 'b7wus' && !['PayByLinkPayment'].includes($route.name)" :showPos="showNiPos"></cybersource> 

		<!-- Ni Pos -->
		<ni-pos v-if="isLoggedIn && roleRef == '7hsy2' && !['PayByLinkPayment'].includes($route.name)"></ni-pos> 

		<router-view/>

		<v-dialog
		v-model="showTimeoutDialogue"
		persistent
		max-width="540"
		>
			<v-card
			id="session-expire-dialogue"
			:class="{ hide: !showTimeoutDialogue }"
			>
				<v-card-title class="text-h5">
				Your session is about to expire
				</v-card-title>

				<v-card-text>
				Your session will expire in {{ getCountdownTimeleft }} due to inactivity. Do you want to extend the session?
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					
					<v-btn
					color="error"
					@click="sessionLogout()"
					>
					Logout
					</v-btn>

					<v-btn
					color="primary"
					@click="sessionContinue()"
					>
					Ok
					</v-btn>
				</v-card-actions>
			</v-card>

		</v-dialog>

	</v-app>
</template>

<script>
	import GodMode from './components/navigations/GodMode.vue';
	import Administrator from './components/navigations/Administrator.vue';
	import Manager from './components/navigations/Manager.vue';
	import SuperUser from './components/navigations/SuperUser.vue';
	import UserHigh from './components/navigations/UserHigh.vue';
	import UserMedium from './components/navigations/UserMedium.vue';
	import UserLow from './components/navigations/UserLow.vue';
	import Cybersource from './components/navigations/Cybersource.vue';
	import NiPos from './components/navigations/NiPos.vue';

	export default {
		name: 'App',

		components: {
			'god-mode': GodMode,
			'administrator': Administrator,
			'manager': Manager,
			'super-user': SuperUser,
			'user-high': UserHigh,
			'user-medium': UserMedium,
			'user-low': UserLow,
			'cybersource': Cybersource,
			'ni-pos': NiPos
		},

		data: () => {
			return {}
		},

		methods: {
			sessionContinue() {
				this.$store.dispatch('refreshSessionTimers').autoLogoutModule;
			},

			sessionLogout() {
				this.$store.dispatch('clearTimers').autoLogoutModule;
				this.$store.dispatch('logout');
			},
		},

		computed: {
			isLoggedIn() {
				return this.$store.getters.isLoggedIn;
			},

			roleRef() {
				return this.$store.getters.roleRef;
			},

			showNiPos() {
				var parsedAccess = JSON.parse(this.$store.getters.niMerchantAccess);

				console.log("parsedAccess", parsedAccess);

				if (!(parsedAccess === undefined || parsedAccess === null)) {
					if (parsedAccess.length > 0) {
						return true;
					}
				}

				return false;
			},

			showTimeoutDialogue() {
				return this.$store.state.autoLogoutModule.session.dialogues.countdown.show;
			},

			getCountdownTimeleft() {
				return this.$store.state.autoLogoutModule.session.dialogues.countdown.timeLeft;
			},
		},
	};
</script>

<style>
	html, body {
		font-family: 'Raleway', sans-serif;
	}

	body .theme--light.v-application {
		background-color: #fafafa;
	}

	body .v-application--wrap {
		padding: 0px 0px 0px 55px;
	}
	
	.hide {
		visibility: hidden !important;
	}
</style>